import React from 'react'
import type { PresentationBlockProps } from '../../'
import compareBlockProps from '../../util/compareBlockProps'
import QuoteTerms from '../../../Quote/QuoteTerms'
import TermsPlaceholder from './TermsPlaceholder'
import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

const useStyles = makeStyles(
  (theme: Theme) => ({
    quotePaper: {
      // sames styles as $paper in Quote
      background: theme.palette.common.white,
      border: `1px solid #888`,
      borderRadius: theme.borderRadius.md,
      boxShadow: 'none',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 0,
      padding: theme.spacing(8),
      position: 'relative',
      width: '100%',
      [theme.breakpoints.down('md')]: {
        width: '100%'
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(3),
        width: '100%'
      },
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(3, 2),
        marginBottom: 0
      }
    }
  }),
  { name: 'TermsBlock' }
)

function TermsBlock(props: PresentationBlockProps) {
  const classes = useStyles(props)
  const { WrapperComponent, isSettings, isInvoice } = props

  return (
    <WrapperComponent {...props}>
      {isSettings ? (
        <TermsPlaceholder />
      ) : (
        <div className={isInvoice ? classes.quotePaper : undefined}>
          <QuoteTerms />
        </div>
      )}
    </WrapperComponent>
  )
}

export default React.memo(TermsBlock, (prevProps, nextProps) => {
  return compareBlockProps(prevProps, nextProps)
})
